import { AfterViewInit, Component, Input } from '@angular/core';
import { AbstractControl, FormControl, ValidationErrors } from '@angular/forms';

@Component({
    selector: 'cmn-errors',
    templateUrl: './errors.component.html',
    styleUrls: ['./errors.component.scss']
})
export class ErrorsComponent {

    @Input() control: AbstractControl;

    constructor() {
    }
}
